import { ChangeEvent, FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CallReason } from '../../api';
import './style.scss';

interface ReasonsCardProps {
    reasons: CallReason[];
    selectedReasonCode: number;
    onChange: (reason: number) => void;
    labels?: {
        ru: string;
        kz: string;
        en: string;
    }
}

export const ReasonsCard: FC<ReasonsCardProps> = (props) => {
    const { onChange, reasons, selectedReasonCode, labels } = props;
    const [selectedReason, setSelectedReason] = useState<number>(selectedReasonCode);
    const { i18n, t } = useTranslation('form');

    const getReasonName = (reason: CallReason) => {
        const lang = i18n.language;
        if (lang === 'kz') {
            return reason.nameKz;
        }

        if (lang === 'en' && reason.nameEn) {
            return reason.nameEn;
        }

        return reason.nameRu;
    };

    const onValueChange = (event: ChangeEvent<HTMLInputElement>) => {
        const code = parseInt(event.target.value, 10);
        setSelectedReason(code);
        onChange(code);
    };

    const getReasonsLabel = () => {
        return labels[i18n.language as 'ru' | 'kz' | 'en'] || t('reason.label');
    };

    return <div className='vb-reasons-card vb-card'>
        <div className='vb-fw-bold vb-mb-2 vb-px-3 vb-pt-3'>
            {getReasonsLabel()}
        </div>
        <ul className='vb-list-group vb-mt-0'>
            {reasons.map((reason) => {
                return <li className='vb-list-group-item vb-d-flex vb-justify-content-between vb-align-items-center vb-px-3 vb-form-check' key={`reason-${reason.code}`}>
                    <label className='vb-form-check-label vb-w-100' htmlFor={`reason-${reason.code}`}>{getReasonName(reason)}</label>
                    <input
                        id={`reason-${reason.code}`}
                        className='vb-form-check-input'
                        type='radio'
                        value={reason.code}
                        checked={reason.code === selectedReason}
                        onChange={onValueChange}
                    />
                </li>;
            })}
        </ul>
    </div>;
};
